export const swePnr = input => {
  //- Empty fields are ok
  if (!input) {
    return true
  }
  if (input.length === 13) {
    // eslint-disable-next-line no-param-reassign
    input = input.replace(/\D/g, '')
  }
  //- Check for 12 didgits (and split with regexp)
  if (!input.match(/^(\d{4})(\d{2})(\d{2})(\d{4})$/)) {
    return false
  }

  //- Declare variables
  var d = new Date(RegExp.$1, RegExp.$2, RegExp.$3),
    digit,
    i,
    numdigits = input.length,
    parity = numdigits % 2,
    sum = 0

  //- Check valid date
  if (Object.prototype.toString.call(d) !== '[object Date]' || isNaN(d.getTime())) {
    return false
  }

  //- Check luhn algorithm
  for (i = 2; i < numdigits; i += 1) {
    digit = parseInt(input.charAt(i))
    if (i % 2 === parity) {
      digit *= 2
    }
    if (digit > 9) {
      digit -= 9
    }
    sum += digit
  }
  //- Return result
  return sum % 10 === 0
}
